/* eslint-disable @typescript-eslint/naming-convention */
import pushClevertapEvent from '../pushClevertapEvent';

export function settingEmailStart(settings) {
  pushClevertapEvent('Setting Notification Start', {
    'Daily Enable': settings.daily_sales_summary,
    'Product Enable': settings.product_updates,
    'Inventory Enable': settings.inventory_alerts,
    'List of Recipients':
      settings.setting_alert_recipients &&
      settings.setting_alert_recipients.map((sar) => sar.email),
  });
}

export function settingEmailSave({ settings }) {
  pushClevertapEvent('Setting Notification Save Successful', {
    'Daily Enable': settings.daily_sales_summary,
    'Product Enable': settings.product_updates,
    'Inventory Enable': settings.inventory_alerts,
    'List of Recipients':
      settings.setting_alert_recipients &&
      settings.setting_alert_recipients.map((sar) => sar.email),
  });
}

export function settingEmailAddRecipient(recipients, previousRecipients) {
  const addedRecipients = recipients.filter(
    (rec) => !previousRecipients.includes(rec)
  );
  const recipientEmails =
    addedRecipients && addedRecipients.map((recipient) => recipient.email);

  pushClevertapEvent('Setting Notification Add Email Recipient', {
    'Email Recipient': recipientEmails,
  });
}
